



























































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import CompanyDetails from '@/components/Companies/CompanyDetails.vue';
import CompanyContactsList from '@/components/Companies/CompanyContactList.vue';
import CompanyAddressMasterDetails from '@/components/Companies/CompanyAddressesMasterDetails.vue';
import CompanyLocationsList from '@/components/Companies/CompanyLocationList.vue';
import CompanyBookingsList from '@/components/Companies/CompanyBookingsList.vue';
import CompanyRateCards from '@/components/RateCards/CompanyRateCards.vue';
import CompanyDto from '@/models/Companies/CompanyDto';
import PageNames from '@/router/PageNames';
import Alert from '@/components/Shared/Alert.vue';
import PrepareForLaunch from '@/components/Shared/PrepareForLaunch.vue'
import Notes from '@/components/Notes/Notes.vue';
import EntityType from '@/models/Shared/EntityType';
import GiganautVue from '@/components/Shared/GiganautVue'
import Documents from '@/components/Documents/Documents.vue';
import ActivityTimeline from '@/components/Activities/ActivityTimeline.vue';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';

@Component({
  name: 'Company',
  components: { CompanyDetails, CompanyLocationsList, CompanyContactsList, CompanyBookingsList, CompanyAddressMasterDetails, CompanyRateCards, Notes, Documents, PrepareForLaunch, Alert, ActivityTimeline, TaskGrid }
})
export default class extends GiganautVue {

  entityType = EntityType.Company;
  activityEntityType = ActivityEntityType.Company;

  get currentCompany() {
    return CompanyDetailsModule.currentCompany;
  }

  get loading() {
    return CompanyDetailsModule.loading;
  }


  navigateToCompanyList() {
    this.$router.push({ name: 'AgencyCompanies' });
  }

  switchToCompanyScope() {
    //AppModule.setCompanyScope(CompanyModule.currentCompany);
    //this.$router.push({ name: PageNames.CompanyBookings, params: { companyid: this.$route.params.companyid } });
  }
 
  // watch: {
  //   // eslint-disable-next-line
  //   "$route.params.id"(val) {
  //     this.$store.dispatch('GET_COMPANY', val);
  //   },
  // },
}
